import { useCallback, useEffect, useState } from 'react'
import Navbar from '../../../components/Navbar'
import { defaultPaginator, IPaginator } from '../../../components/Common/PaginatorServer'
import { INITIAL_ROWS_PER_PAGE } from '../../Products/components/TableDataPagination'
import SnackBarUtils from '../../../utils/SnackBarUtils'
import { getPerfilIncompleto } from '../Vencimientos/contracts.services'
import TablaLocales from './TablaLocales'
import { Box, Chip, Typography, useMediaQuery, useTheme } from '@mui/material'
import CardsLocales from './CardsLocales'

export interface LocalesPerfilImp {
  clienteNombre: string
  clienteCodigoLocal: string
  clienteWhatsapp: string
  idContrato: number
  contratoFechaFin: string
  productoNombre: string
}

const PerfilImpositivo: React.FC = () => {
  const [locales, setLocales] = useState<LocalesPerfilImp[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [page, setPage] = useState<number>(0)
  const [size, setSize] = useState<number>(INITIAL_ROWS_PER_PAGE)
  const [paginator, setPaginator] = useState<IPaginator>(defaultPaginator)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  paginator.handleChangePage = (e: any, newPage: number) => {
    setPage(newPage)
  }

  paginator.handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newPageSize = parseInt(event.target.value, 10)
    setPage(0)
    setSize(newPageSize)
  }

  const fetchLocales = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getPerfilIncompleto(page, size)
      setLocales(res.data.data.results)
      setPaginator({
        ...paginator,
        pageNumber: res?.data.data.pageNumber,
        pageSize: res?.data.data.pageSize,
        totalPages: res?.data.data.totalPages,
        totalElements: res?.data.data.totalElements
      })
    } catch (e) {
      console.log(e)
      SnackBarUtils.error(e.message === 'Network Error' ? 'Ocurrió un error al obtener los locales' : e.message)
    } finally {
      setLoading(false)
    }
  }, [page, size])

  useEffect(() => {
    fetchLocales()
  }, [page, size])

  const formatDate = (date: string) => {
    if (!date) return '-'
    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

  return (
    <>
      <Navbar title="Perfil Impositivo Incompleto" />
      <Box sx={{ my: '1rem', mx: 2 }}>
        <Typography sx={{ marginBottom: '1rem' }} variant="body1" fontWeight={600} color="text.primary">
          Locales con perfil impositivo incompleto
        </Typography>

        {isMobile ? (
          <CardsLocales locales={locales} loading={loading} paginator={paginator} formatDate={formatDate} />
        ) : (
          <TablaLocales locales={locales} loading={loading} paginator={paginator} formatDate={formatDate} />
        )}
      </Box>
    </>
  )
}

export default PerfilImpositivo
